module.exports = {
    sending: 'sending',
    delivered: 'delivered',
    noPhone: 'noPhone',
    noConsent: 'noConsent',
    failed: 'failed',
    undelivered: 'undelivered',
    optedOut: 'optedOut',
};
